export default __webpack_public_path__ + "ee096cfa86f0d336c1e915cae9ce8554.png";